module.exports = __webpack_public_path__ + "static/img_0061_dpp_optimized-4b007b5efe28e49e8d17cd5eb0d5c4fd.jpg";